export const caseFilterOptions = [
  { value: "all", label: "All" },
  { value: "roles", label: "My Team's Cases" },
  { value: "created", label: "Created by Me" },
  { value: "assigned", label: "Assigned to Me" },
]
